import { render, staticRenderFns } from "./pricingProduct.vue?vue&type=template&id=5bae1166"
import script from "./pricingProduct.vue?vue&type=script&lang=js"
export * from "./pricingProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports